module.exports = __webpack_public_path__ + "media/images/countryrect/romani-3bd5c9fab5f2cc573043420271042a90.svg";